"use client";

import { useState } from "react";

import type { FragmentType } from "../../../../../../__generated__/gql";
import { categorySlugToCategory } from "../_utils/spot-category";

import { SpotsCategoryTabs } from "./spots-category-tabs";
import type { SpotsListFragment } from "./spots-list";
import { SpotsList } from "./spots-list";

/**
 * カテゴリタブ + 一覧をまとめたクライアント側ブラウザ。
 * 全スポットは初回 SSR で取得済みなので、 タブ切替はサーバー往復せず
 * クライアント側の filter で即時反映する。 URL (?category=) は共有・リロード整合の
 * ため history API でクエリだけ差し替える (router 遷移はサーバー再フェッチを招くため避ける)。
 */
export function SpotsBrowser({
  areaSlug,
  area,
  initialSlug,
}: {
  areaSlug: string;
  area: FragmentType<typeof SpotsListFragment>;
  initialSlug: string | null;
}) {
  const [activeSlug, setActiveSlug] = useState(initialSlug);
  const activeCategory = categorySlugToCategory(activeSlug);

  const handleSelect = (slug: string | null) => {
    setActiveSlug(slug);
    const url =
      slug === null
        ? `/areas/${areaSlug}/spots`
        : `/areas/${areaSlug}/spots?category=${slug}`;
    window.history.replaceState(null, "", url);
  };

  return (
    <>
      <SpotsCategoryTabs
        areaSlug={areaSlug}
        activeSlug={activeSlug}
        onSelect={handleSelect}
      />
      <SpotsList area={area} activeCategory={activeCategory} />
    </>
  );
}
